import React from 'react';
import ReactDOM from 'react-dom';
import 'rheostat/initialize';
import 'shared/components/hawksearch/styles/app.scss';
import HawkSearch from 'shared/components/hawksearch/components/HawkSearch';
import QueryStringListener from 'shared/components/hawksearch/components/QueryStringListener';
import SearchBox from 'shared/components/hawksearch/components/ui/SearchBox/SearchBox';
import { parseLocation } from 'shared/components/hawksearch/util/QueryString';
import hawkConfig from './RocHawkConfig';
import GlobalSearchBox from 'shared/components/hawksearch/components/ui/SearchBox/GlobalSearchBox';
import { initReactApp } from 'shared/util/ApplicationInit';
import SearchResultListener from './SearchResultListener';
import VisuallyHiddenAnnouncement from 'shared/components/VisuallyHiddenAnnouncement';
import FacetsAndResults from './FacetsAndResults';

// pull the initial search from location
const searchRequest = parseLocation(location);

function SearchBoxPortal() {
	const searchBoxDom = document.getElementById('searchbox');
	if (!searchBoxDom) {
		return null;
	}

	// Use the global search box on landing pages.
	const searchBoxComponent = searchRequest.CustomUrl ? <GlobalSearchBox /> : <SearchBox />;
	return ReactDOM.createPortal(searchBoxComponent, searchBoxDom);
}

function App() {
	return (
		<HawkSearch config={hawkConfig} initialSearch={searchRequest}>
			<SearchResultListener />
			<QueryStringListener />
			<div className="hawk roc-container">
				<SearchBoxPortal />
				<div className="hawk__body">
					<VisuallyHiddenAnnouncement>
						<FacetsAndResults />
					</VisuallyHiddenAnnouncement>
				</div>
			</div>
		</HawkSearch>
	);
}

const render = initReactApp(() => <App />, 'search-results');

render();
